<template>
  <div>
    <div class="h2">
      Vos coordonnées
    </div>

    <!-- Adresse -->
    <input-text
      label="Adresse"
      slug="adresse"
      :model="adresse"
      :v$="v$"
      @input="$emit('update:adresse',$event.target.value)"
    />

    <!-- Code postal et ville de la banque -->
    <zip-code-and-city-form
      :code-postal="codePostal"
      code-postal-slug="codePostal"
      code-postal-label="Code postal"
      :ville="ville"
      ville-slug="ville"
      ville-label="Ville"
      :v$="v$"
      @update-code-postal="$emit('update:codePostal', $event)"
      @update-ville="$emit('update:ville', $event)"
    />

    <!-- Email -->
    <input-text
      label="Email"
      slug="email"
      :model="email"
      :v$="v$"
      @input="$emit('update:email',$event.target.value)"
    />

    <!-- Consentement démarchage -->
    <input-radio
      label="J’accepte qu’un conseiller Swiss Life m’appelle pour m’aider à optimiser au mieux mes garanties, mes besoins et mon budget."
      slug="consent"
      :model="consent"
      :options="[
        {'label': 'Oui', 'value': '1'},
        {'label': 'Non', 'value': '0'}
      ]"
      :v$="v$"
      @input="$emit('update:consent', $event.target.value)"
    />

    <!-- Téléphone -->
    <input-text
      v-if="consent === '1'"
      label="Téléphone"
      slug="telephone"
      :model="telephone"
      :v$="v$"
      @input="$emit('update:telephone',$event.target.value)"
    />

    <!-- Opt in -->
    <input-checkbox-simple
      label="J’accepte expressément de recevoir des offres commerciales par e-mail ou SMS de la part du groupe Swiss Life France."
      slug="optin"
      :model="optin"
      :true-value="'1'"
      :false-value="'2'"
      :v$="v$"
      @change-value="$emit('update:optin', $event)"
    />
  </div>
</template>

<script>

import ZipCodeAndCityForm from "src/modules/shared/components/Form/ZipCodeAndCityForm";
import InputText from "src/modules/shared/components/Form/InputText";
import InputCheckboxSimple from "src/modules/shared/components/Form/InputCheckboxSimple";
import InputRadio from "src/modules/shared/components/Form/InputRadio";
import {computed, ref} from "vue";
import {serverError, required, requiredIf, frenchZipCode} from "src/modules/shared/validators/validators";
import useVuelidate from "@vuelidate/core";

export default {
  name: "ContactInformationForm",
  components: {
    InputCheckboxSimple,
    InputRadio,
    InputText,
    ZipCodeAndCityForm
  },
  props: {
    serverErrors: {
      type: Array,
      required: true
    },
    adresse: {
      type: String,
      default: ''
    },
    codePostal: {
      type: String,
      default: ''
    },
    ville: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    consent: {
      type: String,
      default: ''
    },
    telephone: {
      type: String,
      default: ''
    },
    optin: {
      type: String,
      default: ''
    },
  },
  emits: [
    'update:adresse',
    'update:codePostal',
    'update:ville',
    'update:email',
    'update:consent',
    'update:telephone',
    'update:optin',
  ],
  setup (props) {
    const validations = computed(() => ({
      adresse: {
        required,
        serverError: serverError(props, 'adresse')
      },
      codePostal: {
        required,
        frenchZipCode,
        serverError: serverError(props, 'codePostal')
      },
      ville: {
        required,
        serverError: serverError(props, 'ville')
      },
      email: {
        required,
        serverError: serverError(props, 'email')
      },
      consent: {
        required,
        serverError: serverError(props, 'consent')
      },
      telephone: {
        requiredIf: requiredIf(props.consent === '1'),
        serverError: serverError(props, 'telephone')
      },
      optin: {
        required,
        serverError: serverError(props, 'optin')
      }
    }))

    const v$ = useVuelidate(validations, props)

    const citiesAvailable = ref([])

    return { v$, citiesAvailable }
  },
  watch: {
    serverErrors () {
      this.v$.$reset()
      this.v$.$touch()
    }
  },
}
</script>

<style scoped>

</style>
